// feat_347 — Tab "Automatizaciones" de /Settings.
// feat_352 — Fase 2 paso 2: acá se fusionó el tab "Inteligencia artificial",
// que DESAPARECIÓ. Los 3 bloques de IA (control del admin, IA fuera de horario,
// respuesta automática a media) se movieron VERBATIM desde `tabs/TabIA.js`, que
// se borró. Razón de la fusión: los 3 escenarios de auto-cierre disparan
// webhooks a n8n, `aiSilenceOnTicketOpen` e `iaScheduleEnabled` son gates de la
// MISMA IA, y las acciones por tipo de media terminan en "Pasar a IA" — es todo
// el mismo sistema. En el mismo paso salió de acá el "Reporte por email", que
// ahora vive en `tabs/TabReporteEmail.js` (no tenía relación temática con el
// auto-cierre ni con la IA, y este tab quedaba con 11 bloques).
//
// ORDEN de los 8 bloques, de configuración general a específica:
//   1. Control de IA del admin        [gate: iaAdminCanToggle]
//   2. IA fuera de horario            [gate: secretariaIaEnabled]
//   3. Respuesta automática a media
//   4. Escenario 1 — Carrito abandonado
//   5. Escenario 2 — Sin atender
//   6. Escenario 3 — Ticket olvidado
//   7. Configuración clásica (Accordion)
//   8. Continuidad de conversación
//
// 🔴 REGLA #1 DE ESTA PANTALLA: los 8 TabPanel quedan SIEMPRE MONTADOS (el shell
// los oculta con `hidden`, nunca los desmonta). 26 campos de texto guardan con
// `onBlur`; si al cambiar de tab React desmontara el input, el onBlur NO dispara
// y el usuario pierde lo tipeado sin ningún aviso. NO convertir esto en render
// condicional ni en lazy. Este tab es el que MÁS campos de texto tiene (11
// `onBlur`): acá la regla no es teórica.
//
// ⚠ El Alert de E1 tiene el botón "Ir a horario comercial", que llama
// `goToTab("negocio", "business-hours-section")`. El ancla vive en TabNegocio:
// un getElementById directo devolvería null y el botón quedaría mudo EN
// SILENCIO. Al mover bloques dentro del tab, ese llamado no se toca.
//
// Todo el estado vive en el padre (`Settings/index.js`) y llega por `ctx`.
// El JSX es un MOVIMIENTO VERBATIM — este paso no cambia ni un pixel; el restyle
// con el patrón de feat_351 viene en su propio paso.

import React from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Alert from "@material-ui/lab/Alert";
import Box from "@material-ui/core/Box";
import Tooltip from "@material-ui/core/Tooltip";

import { i18n } from "../../../translate/i18n.js";
import WeeklySchedulePicker from "../../../components/WeeklySchedulePicker";
import { MEDIA_TYPES } from "../mediaActions";

const TabAutomatizaciones = ({ ctx }) => {
	const {
		classes,
		saveSetting,
		goToTab,
		// --- IA (venían de TabIA.js, feat_352) ---
		// Control de IA del admin (gate: iaAdminCanToggle)
		iaAdminCanToggle,
		secretariaIaEnabled,
		vendedorIaEnabled,
		secretariaIaActive,
		vendedorIaActive,
		aiSilenceOnTicketOpen,
		handleToggleSecretariaIaAdmin,
		handleToggleVendedorIaAdmin,
		handleToggleAiSilenceOnTicketOpen,
		// IA fuera de horario (gate: secretariaIaEnabled)
		iaScheduleEnabled, setIaScheduleEnabled,
		// Respuesta automática a media
		autoReplyMediaEnabled, setAutoReplyMediaEnabled,
		autoReplyMediaScope, setAutoReplyMediaScope,
		autoReplyMediaActions, setAutoReplyMediaActions,
		autoReplyMediaTexts, setAutoReplyMediaTexts,
		autoReplyMediaTimeout, setAutoReplyMediaTimeout,
		// --- Auto-cierre ---
		// E1 lee businessHours (del tab Negocio) para el Alert de "no tenés horario"
		businessHours,
		cartAbandonedEnabled, setCartAbandonedEnabled,
		cartAbandonedHours, setCartAbandonedHours,
		cartAbandonedScheduleMode, setCartAbandonedScheduleMode,
		cartAbandonedSchedule, setCartAbandonedSchedule,
		unansweredEnabled, setUnansweredEnabled,
		unansweredHours, setUnansweredHours,
		forgottenEnabled, setForgottenEnabled,
		forgottenHours, setForgottenHours,
		autoCloseEnabled, setAutoCloseEnabled,
		autoCloseHours, setAutoCloseHours,
		autoCloseNotifyMinutes, setAutoCloseNotifyMinutes,
		autoCloseFarewellMessage, setAutoCloseFarewellMessage,
		autoCloseNotifyAI, setAutoCloseNotifyAI,
		ticketReopenWindowDays, setTicketReopenWindowDays,
		ticketReopenWindowMax,
		handleSaveReopenWindow,
	} = ctx;

	return (
		<>
			{/* Admin IA control — independent of webhook fields gate (feat_181) */}
			{iaAdminCanToggle && (
				<Paper style={{ padding: 16, marginBottom: 12 }}>
					<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
						🤖 {i18n.t("settings.iaControlSectionTitle")}
					</Typography>
					{/* Secretaria IA */}
					<Box display="flex" alignItems="flex-start" mb={2}>
						<Switch
							color="primary"
							checked={secretariaIaEnabled}
							onChange={(e) => handleToggleSecretariaIaAdmin(e.target.checked)}
						/>
						<Box ml={1}>
							<Typography variant="subtitle2">{i18n.t("settings.secretariaIaLabel")}</Typography>
							<Typography variant="caption" display="block" color="textSecondary">
								{i18n.t("settings.secretariaIaHelp")}
							</Typography>
							<Typography variant="caption" display="block" style={{ fontWeight: 600 }}>
								{i18n.t("settings.iaActiveStatus")}:{" "}
								<span style={{ color: secretariaIaActive ? "#25D366" : "#b0b0b0" }}>
									{secretariaIaActive ? i18n.t("settings.iaStatusOn") : i18n.t("settings.iaStatusOff")}
								</span>
							</Typography>
						</Box>
					</Box>

					{/* Vendedor IA */}
					<Box display="flex" alignItems="flex-start" mb={2} style={!secretariaIaEnabled ? { opacity: 0.5 } : {}}>
						<Tooltip title={!secretariaIaEnabled ? i18n.t("settings.vendedorIaDisabledTooltip") : ""} arrow>
							<span>
								<Switch
									color="primary"
									disabled={!secretariaIaEnabled}
									checked={vendedorIaEnabled && secretariaIaEnabled}
									onChange={(e) => handleToggleVendedorIaAdmin(e.target.checked)}
								/>
							</span>
						</Tooltip>
						<Box ml={1}>
							<Typography variant="subtitle2">{i18n.t("settings.vendedorIaLabel")}</Typography>
							<Typography variant="caption" display="block" color="textSecondary">
								{i18n.t("settings.vendedorIaHelp")}
							</Typography>
							<Typography variant="caption" display="block" style={{ fontWeight: 600 }}>
								{i18n.t("settings.iaActiveStatus")}:{" "}
								<span style={{ color: (vendedorIaActive && secretariaIaActive) ? "#25D366" : "#b0b0b0" }}>
									{(vendedorIaActive && secretariaIaActive) ? i18n.t("settings.iaStatusOn") : i18n.t("settings.iaStatusOff")}
								</span>
							</Typography>
						</Box>
					</Box>

					{/* Silenciar IA al tomar el ticket */}
					<Box display="flex" alignItems="flex-start" mb={1}>
						<Switch
							color="primary"
							checked={aiSilenceOnTicketOpen}
							onChange={(e) => handleToggleAiSilenceOnTicketOpen(e.target.checked)}
						/>
						<Box ml={1}>
							<Typography variant="subtitle2">{i18n.t("settings.aiSilenceOnTicketOpenLabel")}</Typography>
							<Typography variant="caption" display="block" color="textSecondary">
								{i18n.t("settings.aiSilenceOnTicketOpenHelp")}
							</Typography>
						</Box>
					</Box>
				</Paper>
			)}

			{secretariaIaEnabled && (
				<>
					<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
						{i18n.t("settings.iaScheduleSectionTitle")}
					</Typography>
					<Paper style={{ padding: 16, marginBottom: 12 }}>
						<FormControlLabel
							control={
								<Switch
									color="primary"
									checked={iaScheduleEnabled}
									onChange={async (e) => {
										setIaScheduleEnabled(e.target.checked);
										await saveSetting("iaScheduleEnabled", e.target.checked ? "true" : "false");
									}}
								/>
							}
							label={i18n.t("settings.iaScheduleEnabledLabel")}
						/>
						<Typography variant="caption" display="block" color="textSecondary">
							{i18n.t("settings.iaScheduleEnabledHelp")}
						</Typography>
					</Paper>
				</>
			)}

			{/* Auto-respuesta a media entrante */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
				{i18n.t("settingsExtra.autoReplyMediaSectionTitle")}
			</Typography>
			<Paper className={classes.paper} style={{ flexDirection: "column", alignItems: "flex-start" }}>
				<FormControlLabel
					control={
						<Switch
							checked={autoReplyMediaEnabled}
							onChange={async (e) => {
								const val = e.target.checked;
								setAutoReplyMediaEnabled(val);
								await saveSetting("autoReplyMediaEnabled", val ? "true" : "false");
							}}
							color="primary"
						/>
					}
					label={i18n.t("settingsExtra.autoReplyMediaEnabledLabel")}
				/>
				<Typography variant="caption" display="block" color="textSecondary" style={{ marginLeft: 46 }}>
					{i18n.t("settingsExtra.autoReplyMediaEnabledHelp")}
				</Typography>

				<div style={{ opacity: autoReplyMediaEnabled ? 1 : 0.5, pointerEvents: autoReplyMediaEnabled ? "auto" : "none", marginTop: 16, width: "100%" }}>
					<Typography variant="body2" gutterBottom>{i18n.t("settingsExtra.autoReplyMediaScopeLabel")}</Typography>
					<Select
						native
						value={autoReplyMediaScope}
						onChange={async (e) => {
							const val = e.target.value;
							setAutoReplyMediaScope(val);
							await saveSetting("autoReplyMediaScope", val);
						}}
						style={{ marginBottom: 16, minWidth: 320 }}
					>
						<option value="ai_only">{i18n.t("settingsExtra.autoReplyMediaScopeAiOnly")}</option>
						<option value="always">{i18n.t("settingsExtra.autoReplyMediaScopeAlways")}</option>
					</Select>

					<Typography variant="body2" gutterBottom>{i18n.t("settingsExtra.autoReplyMediaTypesLabel")}</Typography>
					{MEDIA_TYPES.map(cat => {
						const cap = cat.charAt(0).toUpperCase() + cat.slice(1);
						const action = autoReplyMediaActions[cat] || "ai";
						return (
							<div key={cat} style={{ marginBottom: 12, width: "100%" }}>
								<div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
									<Typography variant="body2" style={{ minWidth: 170 }}>
										{i18n.t(`settingsExtra.autoReplyMediaType${cap}`)}
									</Typography>
									<Select
										native
										value={action}
										onChange={async (e) => {
											const val = e.target.value;
											const next = { ...autoReplyMediaActions, [cat]: val };
											setAutoReplyMediaActions(next);
											await saveSetting("autoReplyMediaActions", JSON.stringify(next));
										}}
										style={{ minWidth: 220 }}
									>
										<option value="ai">{i18n.t("settingsExtra.autoReplyMediaActionAi")}</option>
										<option value="ignore">{i18n.t("settingsExtra.autoReplyMediaActionIgnore")}</option>
										<option value="reply">{i18n.t("settingsExtra.autoReplyMediaActionReply")}</option>
									</Select>
								</div>
								{cat === "reaction" && (
									<Typography variant="caption" display="block" color="textSecondary" style={{ marginTop: 2 }}>
										{i18n.t("settingsExtra.autoReplyMediaReactionHelp")}
									</Typography>
								)}
								{action === "reply" && (
									<TextField
										label={i18n.t(`settingsExtra.autoReplyMediaText${cap}`)}
										placeholder={i18n.t("settingsExtra.autoReplyMediaTextPlaceholder")}
										multiline
										minRows={2}
										fullWidth
										variant="outlined"
										margin="dense"
										value={autoReplyMediaTexts[cat] || ""}
										onChange={(e) => {
											const val = e.target.value;
											setAutoReplyMediaTexts(prev => ({ ...prev, [cat]: val }));
										}}
										onBlur={async () => {
											await saveSetting("autoReplyMediaTexts", JSON.stringify(autoReplyMediaTexts));
										}}
									/>
								)}
							</div>
						);
					})}

					<TextField
						label={i18n.t("settingsExtra.autoReplyMediaTextGeneric")}
						placeholder={i18n.t("settingsExtra.autoReplyMediaTextPlaceholder")}
						multiline
						minRows={2}
						fullWidth
						variant="outlined"
						margin="dense"
						value={autoReplyMediaTexts.generic || ""}
						onChange={(e) => {
							const val = e.target.value;
							setAutoReplyMediaTexts(prev => ({ ...prev, generic: val }));
						}}
						onBlur={async () => {
							await saveSetting("autoReplyMediaTexts", JSON.stringify(autoReplyMediaTexts));
						}}
					/>

					<TextField
						type="number"
						label={i18n.t("settingsExtra.autoReplyMediaTimeoutLabel")}
						helperText={i18n.t("settingsExtra.autoReplyMediaTimeoutHelp")}
						value={autoReplyMediaTimeout}
						onChange={(e) => {
							const val = e.target.value;
							setAutoReplyMediaTimeout(val);
						}}
						onBlur={async () => {
							let parsed = parseInt(autoReplyMediaTimeout, 10);
							if (isNaN(parsed)) parsed = 60;
							if (parsed < 10) parsed = 10;
							if (parsed > 600) parsed = 600;
							const finalVal = String(parsed);
							setAutoReplyMediaTimeout(finalVal);
							await saveSetting("autoReplyMediaTimeout", finalVal);
						}}
						inputProps={{ min: 10, max: 600 }}
						margin="dense"
						style={{ marginTop: 12, maxWidth: 240 }}
					/>
				</div>
			</Paper>

			{/* Auto-close 3-scenario */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
				{i18n.t("settingsExtra.automatizacionTickets")}
			</Typography>

			{/* Scenario 1: Carrito abandonado */}
			<Paper style={{ padding: 16, marginBottom: 12 }}>
				<Typography variant="subtitle2" gutterBottom>
					{i18n.t("settingsExtra.escenario1")}
				</Typography>
				<Typography variant="caption" color="textSecondary" display="block" gutterBottom>
					{i18n.t("settingsExtra.descEscenario1")}
				</Typography>
				<FormControlLabel
					control={
						<Switch
							checked={cartAbandonedEnabled}
							onChange={async (e) => {
								setCartAbandonedEnabled(e.target.checked);
								await saveSetting("autoCloseCartAbandonedEnabled", e.target.checked ? "true" : "false");
							}}
							color="primary"
						/>
					}
					label={i18n.t("settingsExtra.activar")}
				/>
				{cartAbandonedEnabled && (
					<div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 12 }}>
						<TextField
							label={i18n.t("settingsExtra.umbralHoras")}
							type="number"
							size="small"
							variant="outlined"
							value={cartAbandonedHours}
							onChange={e => setCartAbandonedHours(e.target.value)}
							onBlur={async () => { await saveSetting("autoCloseCartAbandonedHours", cartAbandonedHours); }}
							inputProps={{ min: 1, max: 720 }}
							style={{ maxWidth: 240 }}
							helperText={i18n.t("settingsExtra.rec4h")}
						/>
						{forgottenEnabled && Number(cartAbandonedHours) >= Number(forgottenHours) && (
							<Typography variant="caption" style={{ color: "#e65100" }}>
								⚠️ El umbral de carrito abandonado ({cartAbandonedHours}h) es mayor o igual al de ticket olvidado ({forgottenHours}h). Ajustá los valores para que tengan sentido.
							</Typography>
						)}

						{/* Modo de horario del aviso (feat_192) */}
						<div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 4 }}>
							<Typography variant="body2">
								{i18n.t("cartAbandonedSchedule.modeLabel")}
							</Typography>
							<Select
								native
								margin="dense"
								variant="outlined"
								value={cartAbandonedScheduleMode}
								style={{ maxWidth: 360 }}
								onChange={async e => {
									const mode = e.target.value;
									setCartAbandonedScheduleMode(mode);
									await saveSetting("autoCloseCartAbandonedScheduleMode", mode);
								}}
							>
								<option value="always">{i18n.t("cartAbandonedSchedule.always")}</option>
								<option value="businessHours">{i18n.t("cartAbandonedSchedule.businessHours")}</option>
								<option value="custom">{i18n.t("cartAbandonedSchedule.custom")}</option>
							</Select>
							<Typography variant="caption" color="textSecondary">
								{cartAbandonedScheduleMode === "always" && i18n.t("cartAbandonedSchedule.helperAlways")}
								{cartAbandonedScheduleMode === "businessHours" && i18n.t("cartAbandonedSchedule.helperBusinessHours")}
								{cartAbandonedScheduleMode === "custom" && i18n.t("cartAbandonedSchedule.helperCustom")}
							</Typography>
							{cartAbandonedScheduleMode === "businessHours" &&
								(!businessHours || !Object.values(businessHours).some(d => Array.isArray(d) ? d.length > 0 : d?.enabled)) && (
								<Alert
									severity="warning"
									style={{ marginTop: 4 }}
									action={
										<Button
											color="inherit"
											size="small"
											// feat_347: Horario comercial vive ahora en OTRO tab. Un
											// getElementById directo devolvería null y el botón quedaría
											// mudo en silencio (el `if (el)` se traga el fallo). goToTab
											// cambia de tab y recién ahí scrollea al ancla.
											onClick={() => goToTab("negocio", "business-hours-section")}
										>
											{i18n.t("cartAbandonedSchedule.goToBusinessHours")}
										</Button>
									}
								>
									{i18n.t("cartAbandonedSchedule.warningNoBusinessHours")}
								</Alert>
							)}
						</div>

						{cartAbandonedScheduleMode === "custom" && (
							<div style={{ marginTop: 4 }}>
								<Typography variant="body2" gutterBottom>
									{i18n.t("cartAbandonedSchedule.customScheduleLabel")}
								</Typography>
								<WeeklySchedulePicker
									value={cartAbandonedSchedule}
									onChange={setCartAbandonedSchedule}
									onCommit={next => saveSetting("autoCloseCartAbandonedSchedule", JSON.stringify(next))}
								/>
							</div>
						)}
					</div>
				)}
			</Paper>

			{/* Scenario 2: Sin atender */}
			<Paper style={{ padding: 16, marginBottom: 12 }}>
				<Typography variant="subtitle2" gutterBottom>
					{i18n.t("settingsExtra.escenario2")}
				</Typography>
				<Typography variant="caption" color="textSecondary" display="block" gutterBottom>
					{i18n.t("settingsExtra.descEscenario2")}
				</Typography>
				<FormControlLabel
					control={
						<Switch
							checked={unansweredEnabled}
							onChange={async (e) => {
								setUnansweredEnabled(e.target.checked);
								await saveSetting("autoCloseUnansweredEnabled", e.target.checked ? "true" : "false");
							}}
							color="primary"
						/>
					}
					label={i18n.t("settingsExtra.activar")}
				/>
				{unansweredEnabled && (
					<div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 12 }}>
						<TextField
							label={i18n.t("settingsExtra.umbralHoras")}
							type="number"
							size="small"
							variant="outlined"
							value={unansweredHours}
							onChange={e => setUnansweredHours(e.target.value)}
							onBlur={async () => { await saveSetting("autoCloseUnansweredHours", unansweredHours); }}
							inputProps={{ min: 1, max: 720 }}
							style={{ maxWidth: 240 }}
							helperText={i18n.t("settingsExtra.rec2h")}
						/>
						{cartAbandonedEnabled && Number(unansweredHours) >= Number(cartAbandonedHours) && (
							<Typography variant="caption" style={{ color: "#e65100" }}>
								⚠️ El umbral de sin atender ({unansweredHours}h) es mayor o igual al de carrito abandonado ({cartAbandonedHours}h). Se recomienda que sin atender sea menor.
							</Typography>
						)}
					</div>
				)}
			</Paper>

			{/* Scenario 3: Ticket olvidado */}
			<Paper style={{ padding: 16, marginBottom: 12 }}>
				<Typography variant="subtitle2" gutterBottom>
					{i18n.t("settingsExtra.escenario3")}
				</Typography>
				<Typography variant="caption" color="textSecondary" display="block" gutterBottom>
					{i18n.t("settingsExtra.descEscenario3")}
				</Typography>
				<FormControlLabel
					control={
						<Switch
							checked={forgottenEnabled}
							onChange={async (e) => {
								setForgottenEnabled(e.target.checked);
								await saveSetting("autoCloseForgottenEnabled", e.target.checked ? "true" : "false");
							}}
							color="primary"
						/>
					}
					label={i18n.t("settingsExtra.activar")}
				/>
				{forgottenEnabled && (
					<div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 12 }}>
						<TextField
							label={i18n.t("settingsExtra.umbralHoras")}
							type="number"
							size="small"
							variant="outlined"
							value={forgottenHours}
							onChange={e => setForgottenHours(e.target.value)}
							onBlur={async () => { await saveSetting("autoCloseForgottenHours", forgottenHours); }}
							inputProps={{ min: 1, max: 720 }}
							style={{ maxWidth: 240 }}
							helperText={i18n.t("settingsExtra.rec24h")}
						/>
						{cartAbandonedEnabled && Number(forgottenHours) <= Number(cartAbandonedHours) && (
							<Typography variant="caption" style={{ color: "#e65100" }}>
								⚠️ El umbral de ticket olvidado ({forgottenHours}h) es menor o igual al de carrito abandonado ({cartAbandonedHours}h). Ajustá los valores para que tengan sentido.
							</Typography>
						)}
					</div>
				)}
			</Paper>

			{/* Legacy auto-close (collapsible) */}
			<Accordion style={{ marginBottom: 12 }}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="caption" color="textSecondary">
						{i18n.t("settingsExtra.configClasica")}
					</Typography>
				</AccordionSummary>
				<AccordionDetails style={{ flexDirection: "column" }}>
					<FormControlLabel
						control={
							<Switch
								checked={autoCloseEnabled}
								onChange={async (e) => {
									const val = e.target.checked ? "enabled" : "disabled";
									setAutoCloseEnabled(e.target.checked);
									await saveSetting("autoCloseInactiveTickets", val);
								}}
								color="primary"
							/>
						}
						label={i18n.t("settingsExtra.activarResolucion")}
					/>
					{autoCloseEnabled && (
						<div style={{ display: "flex", flexDirection: "column", gap: 16, marginTop: 12 }}>
							<TextField
								label={i18n.t("settingsExtra.resolverEn")}
								type="number"
								size="small"
								variant="outlined"
								value={autoCloseHours}
								onChange={e => setAutoCloseHours(e.target.value)}
								onBlur={async () => { await saveSetting("autoCloseInactiveHours", autoCloseHours); }}
								inputProps={{ min: 1, max: 720 }}
								style={{ maxWidth: 260 }}
								helperText={i18n.t("settingsExtra.ticketsSinActividad")}
							/>
							<TextField
								label={i18n.t("settingsExtra.notificarCliente")}
								type="number"
								size="small"
								variant="outlined"
								value={autoCloseNotifyMinutes}
								onChange={e => setAutoCloseNotifyMinutes(e.target.value)}
								onBlur={async () => { await saveSetting("autoCloseNotifyMinutes", autoCloseNotifyMinutes); }}
								inputProps={{ min: 0, max: 1440 }}
								style={{ maxWidth: 300 }}
								helperText={i18n.t("settingsExtra.sinNotificacion")}
							/>
							<TextField
								label={i18n.t("settingsExtra.mensajeDespedida")}
								multiline
								rows={3}
								size="small"
								variant="outlined"
								fullWidth
								value={autoCloseFarewellMessage}
								onChange={e => setAutoCloseFarewellMessage(e.target.value)}
								onBlur={async () => { await saveSetting("autoCloseFarewellMessage", autoCloseFarewellMessage); }}
								placeholder={i18n.t("settingsExtra.phMensajeDespedida")}
								helperText={i18n.t("settingsExtra.enviarAnteCierre")}
							/>
							<FormControlLabel
								control={
									<Switch
										checked={autoCloseNotifyAI}
										onChange={async (e) => {
											setAutoCloseNotifyAI(e.target.checked);
											await saveSetting("autoCloseNotifyAI", e.target.checked ? "true" : "false");
										}}
										color="primary"
									/>
								}
								label={i18n.t("settingsExtra.notificarIA")}
							/>
						</div>
					)}
				</AccordionDetails>
			</Accordion>

			{/* Continuidad de conversación */}
			<Paper className={classes.paper} elevation={0} style={{ flexDirection: "column", alignItems: "flex-start", padding: 16 }}>
				<Typography variant="subtitle1" style={{ fontWeight: 700, marginBottom: 8 }}>
					{i18n.t("settingsExtra.continuidadConversacion")}
				</Typography>
				<Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
					{i18n.t("settingsExtra.descContinuidad")}
				</Typography>
				<div style={{ display: "flex", alignItems: "center", gap: 16 }}>
					<TextField
						label={i18n.t("settingsExtra.diasReapertura")}
						type="number"
						size="small"
						value={ticketReopenWindowDays}
						onChange={(e) => setTicketReopenWindowDays(e.target.value)}
						onBlur={(e) => handleSaveReopenWindow(e.target.value)}
						inputProps={{
							min: 0,
							max: ticketReopenWindowMax !== null ? parseInt(ticketReopenWindowMax, 10) : undefined
						}}
						style={{ width: 140 }}
						helperText={
							ticketReopenWindowMax !== null
								? `Máximo permitido: ${ticketReopenWindowMax === "0" ? "sin límite (0)" : `${ticketReopenWindowMax} días`}`
								: "0 = siempre el mismo chat"
						}
					/>
					<Typography variant="body2" color="textSecondary">
						{ticketReopenWindowDays === "0"
							? "✓ Modo chat continuo — siempre el mismo ticket"
							: `✓ Modo por caso — reabre si el cliente escribe dentro de ${ticketReopenWindowDays} día${ticketReopenWindowDays === "1" ? "" : "s"}`}
					</Typography>
				</div>
			</Paper>
		</>
	);
};

export default TabAutomatizaciones;
